<template>
</template>
<script>
    import AlignmentMixin from "../../../author/pagesbuilder/mixins/AlignmentMixin";

    export default {
        name: "ButtonWrapperElement",
        mixins: [
            AlignmentMixin,
        ],
        data() {
            return {
                givesContextToChildren: true,
                elementType: 'button-wrapper',
            }
        },
        computed: {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    linkData: {},
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                }
            },
        }
    }
</script>
